/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Discounts_Edit_Discount_TitleInputs */

const en_admin_discounts_edit_discount_title = /** @type {(inputs: Admin_Discounts_Edit_Discount_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit Discount`)
};

const de_admin_discounts_edit_discount_title = /** @type {(inputs: Admin_Discounts_Edit_Discount_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rabatt bearbeiten`)
};

const es_admin_discounts_edit_discount_title = /** @type {(inputs: Admin_Discounts_Edit_Discount_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar descuento`)
};

const fr_admin_discounts_edit_discount_title = /** @type {(inputs: Admin_Discounts_Edit_Discount_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifier la réduction`)
};

const nl_admin_discounts_edit_discount_title = /** @type {(inputs: Admin_Discounts_Edit_Discount_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Korting bewerken`)
};

/** @type {(inputs: Admin_Discounts_Edit_Discount_TitleInputs) => LocalizedString} */
const it_admin_discounts_edit_discount_title = en_admin_discounts_edit_discount_title;

/** @type {(inputs: Admin_Discounts_Edit_Discount_TitleInputs) => LocalizedString} */
const pt_br2_admin_discounts_edit_discount_title = en_admin_discounts_edit_discount_title;

/** @type {(inputs: Admin_Discounts_Edit_Discount_TitleInputs) => LocalizedString} */
const pl_admin_discounts_edit_discount_title = en_admin_discounts_edit_discount_title;

/** @type {(inputs: Admin_Discounts_Edit_Discount_TitleInputs) => LocalizedString} */
const hu_admin_discounts_edit_discount_title = en_admin_discounts_edit_discount_title;

/** @type {(inputs: Admin_Discounts_Edit_Discount_TitleInputs) => LocalizedString} */
const ro_admin_discounts_edit_discount_title = en_admin_discounts_edit_discount_title;

/**
* | output |
* | --- |
* | "Edit Discount" |
*
* @param {Admin_Discounts_Edit_Discount_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_discounts_edit_discount_title = /** @type {((inputs?: Admin_Discounts_Edit_Discount_TitleInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Discounts_Edit_Discount_TitleInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_discounts_edit_discount_title(inputs)
	if (locale === "de") return de_admin_discounts_edit_discount_title(inputs)
	if (locale === "es") return es_admin_discounts_edit_discount_title(inputs)
	if (locale === "fr") return fr_admin_discounts_edit_discount_title(inputs)
	if (locale === "nl") return nl_admin_discounts_edit_discount_title(inputs)
	if (locale === "it") return it_admin_discounts_edit_discount_title(inputs)
	if (locale === "pt-BR") return pt_br2_admin_discounts_edit_discount_title(inputs)
	if (locale === "pl") return pl_admin_discounts_edit_discount_title(inputs)
	if (locale === "hu") return hu_admin_discounts_edit_discount_title(inputs)
	return ro_admin_discounts_edit_discount_title(inputs)
});
export { admin_discounts_edit_discount_title as "admin.discounts.edit_discount_title" }